import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BackChevronIcon = (props) => (
    <SvgIcon viewBox='0 0 24 24' {...props}>
        <path d='M15.41 5.41L14 4l-8 8 8 8 1.41-1.41L8.83 12z' />
    </SvgIcon>
);

export default BackChevronIcon;
